import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { DropdownCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import { DropdownFieldDefinitionDto } from '@/components/table/_fieldDefinitions/dropdown/DropdownFieldDefinitionDto.ts';
import Option from '@/components/form/types/Option.ts';

export const DropdownFilterInputs = ({
  form,
  index,
  fieldDef,
}: FilterInputProps) => {
  let options: Option[] = [];
  if (fieldDef) {
    const dropdownField = fieldDef as DropdownFieldDefinitionDto;
    options = dropdownField.options?.map((o) => ({
      value: o.id ?? o.label,
      label: o.label,
    }));
  }
  return (
    <MultiSelectInput
      controlSize="toolbar"
      placeholder="Wpisz wartość"
      fieldPath={`filters.${index}.value`}
      control={form.control}
      options={options}
    />
  );
};
